<template>
  <div class="bgf5">
    <iHeader />
    <iNav />
    <iClassify
      ref="iClassify"
      :active="activeIndex"
      all-active
    />
    <iRightFixedBox />
    <div style="min-height: 600px;">
      <div id="Search-Page">
        <PageTitle
          v-if="getShowTitle().length !== 0"
          firsttext="当前条件"
          type="serach"
          :text="getShowTitle()"
          @clear="clearTitle"
        />
        <div class="search-classify-div">
          <div
            class="search-classify flex-row"
            :class="oneFlag ? 'extends' : ''"
          >
            <div class="title">一级分类</div>
            <div class="classify-listbox flex-row">
              <div
                v-for="i in classifys"
                :key="i.Id"
                :class="i.isCheck ? 'a-classify' : 'classify'"
                @click="searchClassify(i, 1)"
              >{{ i.ClassifyName }}</div>
            </div>
            <div
              class="open_close"
              @click="()=>{
                oneFlag = !oneFlag
              }"
            >
              {{ oneFlag ? '收起' : '展开' }} <i class="el-icon-arrow-down" />
            </div>
          </div>
          <div
            v-if="seconds && seconds.length > 0"
            class="search-classify flex-row"
            :class="twoFlag ? 'extends' : ''"
          >
            <div class="title">二级分类</div>
            <div class="classify-listbox flex-row">
              <div
                v-for="i in seconds"
                :key="i.Id"
                :class="i.isCheck ? 'a-classify' : 'classify'"
                @click="searchClassify(i, 2)"
              >{{ i.ClassifyName }}</div>
            </div>
            <div
              class="open_close"
              @click="()=>{
                twoFlag = !twoFlag
              }"
            >
              {{ twoFlag ? '收起' : '展开' }} <i class="el-icon-arrow-down" />
            </div>
          </div>
          <div class="search-classify flex-row">
            <div class="title">品牌</div>
            <div class="classify-listbox flex-row">
              <div
                v-for="i in brands"
                :key="i.Id"
                :class="i.isCheck ? 'a-classify' : 'classify'"
                @click="searchBrand(i)"
              >{{ i.Name }}</div>
            </div>
          </div>
          <div class="search-classify flex-row">
            <div class="title">医保类型</div>
            <div class="classify-listbox flex-row">
              <div
                v-for="i in MedicalTypes"
                :key="i.Id"
                :class="i.isCheck ? 'a-classify' : 'classify'"
                @click="searchMedicalTypes(i)"
              >{{ i.Name }}</div>
            </div>
          </div>
          <div
            v-if="hasControlBoolean"
            class="search-classify flex-row"
          >
            <div class="title">控销状态</div>
            <div class="classify-listbox flex-row">
              <div
                :class="searchData.IsUnControl ? 'a-classify' : 'classify'"
                @click="isUnControlHanld"
              >非销控品</div>
              <div
                :class="searchData.MyGroupControl ? 'a-classify' : 'classify'"
                @click="myGroupControlHanld"
              >我的控销</div>
              <div
                :class="searchData.IsContinueGroupControl ? 'a-classify' : 'classify'"
                @click="isContinueGroupControlHanld"
              >可增加控销</div>
            </div>
          </div>
        </div>
        <van-sticky @scroll="onScroll">
          <div :class="`${isFixed ? 'fixed-search-other-div bgf5' : 'search-other-div'} flex-row`">
            <div class="search-other flex-row">
              <!-- <div :class="searchData.IsNew ? 'a-other-block' : 'other-block'"
                   @click="searchOther(3)">最新商品</div> -->
              <div
                :class="searchData.SortType === 2 ? 'a-order-block' : 'order-block'"
                @click="searchOther(2)"
              >
                <div
                  class="order"
                  :class="searchData.IsSortAsc ? 'order-asc' : 'order-desc'"
                >
                  销量排序</div>
              </div>
              <div
                :class="searchData.SortType === 1 ? 'a-order-block' : 'order-block'"
                @click="searchOther(1)"
              >
                <div
                  class="order"
                  :class="searchData.IsSortAsc ? 'order-asc' : 'order-desc'"
                >
                  价格排序</div>
              </div>
            </div>
            <div class="search-other flex-row">
              <van-checkbox
                v-model="searchData.IsHasStock"
                shape="square"
                @change="
                  e => {
                    changeOther('IsHasStock');
                  }
                "
              >
                只看有货商品
              </van-checkbox>
              <van-checkbox
                v-model="searchData.IsHasActivity"
                shape="square"
                style="margin-left: 50px;"
                @change="
                  e => {
                    changeOther('IsHasActivity');
                  }
                "
              >
                只看促销商品
              </van-checkbox>
              <van-checkbox
                v-model="searchData.IsRange"
                shape="square"
                style="margin-left: 50px;"
                @change="
                  e => {
                    changeOther('IsRange');
                  }
                "
              >
                仅看营业范围内商品
              </van-checkbox>
            </div>
          </div>
        </van-sticky>
        <div class="flex-box">
          <div
            v-for="goods in dataList"
            :key="goods.Id"
            class="item"
            style="margin: 6px 0;"
            @click.stop="showRouter(goods)"
          >
            <!-- list 组件(普通活动样式，适用于宫格) -->
            <NewProductItem
              ref="NewProductItem"
              :product="goods"
              @click.stop.native="stop"
            />
            <!-- <iProductDetail
              :ref="'p_' + goods.Id"
              :product="_itemToGoods(goods)"
              :goods-tags="goods.GoodsTags && goods.GoodsTags.length > 0 ? goods.GoodsTags : []"
              :activity-tags="goods.ActivityTags && goods.ActivityTags.length > 0 ? goods.ActivityTags : []"
              from-page="AlwaysBuysList"
              :time-out="changeTimeOut(goods.GoodsActivityCountdown)"
              :show-goods-time="!!goods.GoodsActivityCountdown"
              :timer="goods.timer"
            /> -->
          </div>
        </div>

        <template v-if="dataList && !dataList.length && finished">
          <EmptyControl
            style="margin: 20px 0; padding: 100px 0;"
            type="no-data"
            text=" "
            show-new-goods-collect
          />
        </template>

        <div class="page-view">
          {{ IsHasNext ? '向下拉展示更多商品' : '所有商品均已加载完毕' }}
        </div>
      </div>
    </div>
    <iFooter />
    <add-new-goods-collect-tips ref="addNewCollectTipsRef" />
  </div>
</template>

<script>
import iHeader from '@/components/Header'
import iNav from '@/components/Nav'
import iClassify from '@/components/Classify'
import iFooter from '@/components/Footer'
import { BaseMixin } from '@/mixins/BaseMixin'

import PageTitle from '@/components/PageTitle'
import merge from 'webpack-merge'
import iRightFixedBox from '@/components/RightFixedBox'
import AddNewGoodsCollectTips from '@/components/AddNewGoodsCollectTips.vue'
import NewProductItem from '../storey/NewProductItem.vue'

export default {
  name: 'SearchPage',
  components: {
    iHeader,
    iNav,
    iClassify,
    iFooter,

    PageTitle,
    iRightFixedBox,

    AddNewGoodsCollectTips,
    NewProductItem
  },
  mixins: [BaseMixin],
  data() {
    return {
      // 一级展开收起Flag
      oneFlag: false,
      // 2级展开收起flag
      twoFlag: false,
      activeIndex: 1,
      pageindex: 1,
      pageSize: 10,
      totalCount: 0,
      finished: false,
      dataList: [],
      isFixed: false,
      classifys: [],
      // 定时器集合
      intervalMap: [],
      brands: [],
      // 医保类型
      MedicalTypes: [
        {
          Id: 0,
          Name: '非医保',
          isCheck: false
        },
        {
          Id: 1,
          Name: '甲类',
          isCheck: false
        },
        {
          Id: 2,
          Name: '乙类',
          isCheck: false
        },
        {
          Id: 3,
          Name: '医保',
          isCheck: false
        }
      ],
      seconds: [],
      // 控销状态集合
      // controls: [
      // 	{
      // 		Id: '1',
      // 		Name: '已控销',
      // 		isCheck: false
      // 	},
      // 	{
      // 		Id: '2',
      // 		Name: '未控销',
      // 		isCheck: false
      // 	}
      // ],
      // 是否控销组
      hasControlBoolean: false,
      searchParams: {
        classify1: '',
        classify1Name: '',
        classify2: '',
        classify2Name: '',
        brandId: '',
        brandName: '',
        MedicalTypes: '',
        medicalTypesName: [],
        new: '',
        pop: '',
        order: '',
        sales: '',
        isHasStock: false,
        isHasActivity: false,
        isRange: true,
        isSortAsc: true,
        ids: this.$route.query.ids || '', // 使用优惠券跳转 查询可使用列表
        isUnControl: true, // 是否非控销
        myGroupControl: true, // 我的控销
        isContinueGroupControl: true // 可增加控销
      },
      url: {
        getClassify: '/api_goods/OperatingClassify/GetListOwner',
        getBrand: '/clientapi_brand/Brand/Pagging',
        getList: '/api_goods/GoodsSku/ListForCustomerV3',
        getHasControl: '/api_customers/Customer/CustomerIsControlMan',
        createSearchRecord: '/api_customers/CustomerSearchRecord/Create'
      },
      // 改造分页后搜索条件入参对象
      searchData: {
        Offset: 0, // 偏移量
        ClassIds: '', // 分类ID集合  用于（后台配置多选分类使用）
        Ids: this.$route.query.ids || '', // 商品IDS 用于（商品配置 选择指定商品使用）
        SortType: 0, // 排序类型 0 不排序 1 价格 2 销量
        IsSortAsc: true, // 是否正序
        Keyword: '', // 查询关键字
        BrandIds: '', // 品牌ID
        BrandName: '', // 品牌名称
        IsNew: false, // 是否新品
        MedicalTypes: '', // 医保范围List 逗号分隔 0 非医保 1 甲类 2 乙类 3 医保肯能没了
        IsUnControl: true, // 是否非控销
        IsHasStock: false, // 是否仅看有货
        IsHasActivity: false, // 是否商品促销
        MyGroupControl: true, // 是否我的控销 默认true
        IsContinueGroupControl: true, // 是否可增加控销 默认true
        IsRange: true, // 是否只看经营范围 默认true
        SalesPromotionId: '', // 活动ID
        CouponIssueId: '', // 优惠券ID
        Manufactorid: '' // 厂家Id
      },
      // 是否分页标记,后端返回
      IsHasNext: false,
      // 计时器(节流延时跳转，避免快速加载)
      timer: null
    }
  },
  watch: {},
  destroyed() {
    this.$bus.$off('changeSearchClassify')
    this.$bus.$off('reload')
  },
  created() {
    this.$bus.$on('changeSearchClassify', (pdata, data, l) => {
      if (l === 2) {
        this.searchClassify(pdata, 1)
        this.searchClassify(data, 2)
      } else if (l === 1) {
        if (data.ClassifyName !== '查看全部') {
          this.searchClassify(data, l)
        } else {
          this.clearSearch()
          this.onLoad()
        }
      }
    })
    this.$bus.$on('reload', keyword => {
      // 初始化Offset
      this.searchData.Offset = 0
      // 清空table
      this.dataList = []
      // this.searchParams.keyword = keyword
      this.searchData.Keyword = keyword
      this.createSearchRecord(keyword)
      this.onLoad()
    })
  },
  beforeDestroy() {
    // 页面销毁时清除定时器
    if (this.intervalMap.length) {
      this.intervalMap.forEach(el => {
        clearInterval(el)
      })
      this.intervalMap = []
    }
  },
  mounted() {
    if (this.$route.query.category === 'b3fb842e-1364-4dac-a343-ce4cfb154676') {
      this.activeIndex = 7
    }
    if (this.$route.query.category === 'fb5982cc-88e5-4d90-b7e2-7aacf397d99e') {
      this.activeIndex = 6
    }
    // console.log(this.$route.query)
    const keyword = this.$route.query.keyword
    const category = this.$route.query.category
    const isHasStock = this.$route.query.isHasStock
    const isHasActivity = this.$route.query.isHasActivity
    const isNotActivity = this.$route.query.isNotActivity
    const brandId = this.$route.query.brandId
    const ids = this.$route.query.ids
    const couponIssueId = this.$route.query.couponIssueId
    // this.searchParams.keyword = keyword || ''
    // if (category) {
    //   this.searchParams.classify1 = category
    // }
    // if (brandId) {
    //   this.searchParams.brandId = brandId
    // }

    this.searchData.Keyword = keyword || ''
    if (category) {
      this.searchData.classify2 = category
    }
    if (brandId) {
      this.searchData.BrandIds = brandId
    }

    // this.searchParams.couponIssueId = couponIssueId || ''
    // this.searchParams.isHasStock = isHasStock || false
    // this.searchParams.ids = ids || []
    // this.searchParams.isNotActivity = isNotActivity || false
    // this.searchParams.isHasActivity = isHasActivity || false

    this.searchData.CouponIssueId = couponIssueId || ''
    this.searchData.IsHasStock = isHasStock || false
    this.searchData.Ids = ids || []
    this.searchData.IsNotActivity = isNotActivity || false
    this.searchData.IsNotActivity = isHasActivity || false

    this.createSearchRecord(keyword)
    this.getClassify()
    this.getBrand()
    this.hasControl()
    this.onLoad()

    // 绑定监听页面滑动方法
    window.addEventListener('scroll', this.handleSearch)
  },
  methods: {
    stop() {},
    /*
     * 监听页面滑动
     */
    handleSearch() {
      // 获取当前页面高度
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop

      // 获取网页可见区域高
      const clientHeight = document.body.clientHeight
      // 获取网页正文全文高
      const scrollHeight = document.body.scrollHeight

      // 当前页面高度大于指定位置时记录
      if (scrollTop > 600) {
        this.isFixedMenu = true
      } else {
        this.isFixedMenu = false
      }

      // 当前页面高度大于指定位置时记录
      if (scrollTop > 600) {
        this.isFixedMenu = true
      } else {
        this.isFixedMenu = false
      }
      // 到达页面底部时
      if (scrollTop + clientHeight >= scrollHeight - 400 && this.IsHasNext) {
        if (this.timer) {
          clearTimeout(this.timer)
        }
        // 开启加载层
        this.$hys.openLoading()
        this.IsHasNext = false
        // 延时请求
        this.timer = setTimeout(() => {
          // 获取list
          this.onLoad()
        }, 100)
      }
    },
    /*
     * 获取是否控销组商品
     */
    async hasControl() {
      const res = await this.getAction(`${this.url.getHasControl}`)
      if (res.IsSuccess) {
        this.hasControlBoolean = res.Data
      } else {
        this.$toast({ position: 'bottom', message: res.Msg })
      }
    },
    // 切换数据类型
    changeTimeOut(data) {
      let result = {}
      if (data) {
        result = {
          Day: data.Days,
          time: data.TotalMilliseconds,
          IsWillBegin: data.countdownType
        }
      }

      return result
    },
    clearSearch() {
      this.brands.forEach(i => {
        i.isCheck = false
      })
      this.MedicalTypes.forEach(i => {
        i.isCheck = false
      })
      this.classifys.forEach(i => {
        i.isCheck = false
      })
      this.seconds.forEach(i => {
        i.isCheck = false
      })
      // this.controls.forEach(i => {
      // 	i.isCheck = false;
      // });
      this.seconds = []
      this.searchParams = {
        classify1: '',
        classify1Name: '',
        classify2: '',
        classify2Name: '',
        brandId: '',
        brandName: '',
        medicalTypesName: [],
        MedicalTypes: '',
        new: '',
        pop: '',
        order: '',
        sales: '',
        isHasStock: false,
        isHasActivity: false,
        isSortAsc: null,
        isRange: true
      }
      // 改造分页后搜索条件入参对象
      this.searchData = {
        Offset: 0, // 偏移量
        ClassIds: '', // 分类ID集合  用于（后台配置多选分类使用）
        Ids: this.$route.query.ids || '', // 商品IDS 用于（商品配置 选择指定商品使用）
        SortType: '', // 排序类型 0 不排序 1 价格 2 销量
        IsSortAsc: true, // 是否正序
        Keyword: '', // 查询关键字
        BrandIds: '', // 品牌ID
        BrandName: '', // 品牌名称
        IsNew: '', // 是否新品
        MedicalTypes: '', // 医保范围List 逗号分隔 0 非医保 1 甲类 2 乙类 3 医保肯能没了
        IsUnControl: true, // 是否非控销
        IsHasStock: false, // 是否仅看有货
        IsHasActivity: false, // 是否商品促销
        MyGroupControl: true, // 是否我的控销 默认true
        IsContinueGroupControl: true, // 是否可增加控销 默认true
        IsRange: true, // 是否只看经营范围 默认true
        SalesPromotionId: '', // 活动ID
        CouponIssueId: '', // 优惠券ID
        Manufactorid: '' // 厂家Id
      }
    },
    async createSearchRecord(keyword) {
      if (keyword) {
        const res = await this.postAction(`${this.url.createSearchRecord}`, {
          ClientType: 1,
          SearchKey: keyword
        })
        if (!res.IsSuccess) {
          this.$toast({ position: 'bottom', message: res.Msg })
        }
      }
    },
    changeSearchKeyword(keyword) {
      // this.searchParams.keyword = keyword
      this.searchData.Keyword = keyword
      this.onLoad()
    },
    showRouter: function(item) {
      this._jump(
        this.Enum_LinkTypeCode.ProductDetails,
        {
          id: item.Id,
          detailType: item.SourceGoodsSkuId ? 'specialOffer' : '',
          configType: item.GoodsType !== 3 ? '' : '', // 暂留
          ruleText: item.RuleText || ''
        },
        '_blank'
      )
    },
    async onLoad() {
      // this.dataList = []
      await this.loadData()
    },
    async loadData(index) {
      console.log(this.dataList)
      // this.pageindex = index || this.pageindex
      // const operatingClassifyId = this.searchParams.classify2
      //   ? this.searchParams.classify2
      //   : this.searchParams.classify1

      this.searchData.ClassIds = this.searchData.classify2
        ? this.searchData.classify2
        : this.searchData.classify1
      // this.searchParams.operatingClassifyId = operatingClassifyId
      // this.searchParams.pageindex = this.pageindex
      // this.searchParams.pagesize = this.pageSize
      // const sortType = this.searchParams.order
      //   ? 1
      //   : this.searchParams.new
      //     ? 2
      //     : this.searchParams.sales
      //       ? 3
      //       : null
      // const SortType = this.searchData.Order
      //   ? 1
      //   : this.searchData.IsNew
      //     ? 2
      //     : this.searchData.Sales
      //       ? 3
      //       : null
      // this.searchData.SortType = this.searchData.SortType = SortType
      // switch (SortType) {
      //   case 1:
      //     this.searchData.IsSortAsc = this.searchData.Order === 'asc'
      //     break
      //   case 2:
      //     this.searchData.IsSortAsc = false
      //     break
      //   case 3:
      //     this.searchData.IsSortAsc = this.searchData.Sales === 'asc'
      //     break
      //   default:
      //     this.searchData.IsSortAsc = null
      //     break
      // }

      this.$hys.openLoading()
      const res = await this.getAction(`${this.url.getList}`, this.searchData)
      this.$hys.clearLoading()

      // 如果有商品定时器集合，则清除
      if (this.intervalMap.length) {
        this.intervalMap.forEach(el => {
          clearInterval(el)
        })
        this.intervalMap = []
      }
      if (res.IsSuccess) {
        this.finished = true
        // 展示新品收集入口提示
        if (res.Data.length) {
          setTimeout(() => {
            if (!this.$refs.addNewCollectTipsRef.showTips) {
              this.$refs.addNewCollectTipsRef.showTips = true
            }
          }, 1500)
        }

        // 追加到本地数据集合中
        res.Data.GoodsList.forEach(item => {
          this.dataList.push(item)
        })
        // 本地数据集合通过ID去重
        this.dataList = this.dataList.filter(function(element, index, self) {
          return self.findIndex(el => el.Id === element.Id) === index
        })

        // 关闭加载层
        this.$hys.clearLoading()
        // 保存分页标记，由后端返回，第一次第一页，前端默认传递0 （偏移量）
        this.searchData.Offset = res.Data.Offset
        // 保存是否分页标记
        this.IsHasNext = res.Data.IsHasNext

        // 保存接口返回偏移量
        this.searchData.Offset = res.Data.Offset
        // 保存接口返回是否有下一页标记
        this.IsHasNext = res.Data.IsHasNext
      } else {
        this.$toast({ position: 'bottom', message: res.Msg })
        this.finished = true
      }
    },
    async getClassify() {
      const res = await this.getAction(`${this.url.getClassify}`)
      // console.log('获取商品分类', res)
      if (res.IsSuccess) {
        this.classifys = res.Data
        if (this.classifys && this.classifys.length) {
          // this.seconds = this.classifys[0].Children
          // this.searchParams['classify1'] = this.classifys[0].Id
        }
        const pclassify = this.$route.params.pclassify
        const classify = this.$route.params.classify
        const level = this.$route.params.level
        // console.log(pclassify)
        if (pclassify || classify || level) {
          if (level === 2) {
            this.searchClassify(pclassify, 1)
            this.searchClassify(classify, 2)
          } else if (level === 1) {
            if (classify.ClassifyName !== '查看全部') {
              this.searchClassify(classify, level)
            } else {
              this.clearSearch()
              this.onLoad()
            }
          }
        }
      } else {
        this.$toast({ position: 'bottom', message: res.Msg })
      }
    },
    async getBrand() {
      const res = await this.getAction(
        `${this.url.getBrand}?page=1&pagesize=999`
      )
      if (res.IsSuccess) {
        this.brands = res.Data
      } else {
        this.$toast({ position: 'bottom', message: res.Msg })
      }
    },
    searchClassify(classify, level) {
      this.$router.push({
        query: merge(this.$route.query, { category: '', name: '' })
      })
      if (level === 1) {
        this.classifys.forEach(i => {
          i.isCheck = false
          if (i.Id === classify.Id) {
            i.isCheck = true
          }
        })
        this.seconds.forEach(i => {
          i.isCheck = false
        })

        this.searchData['classify1'] = classify.Id
        this.searchData['classify1Name'] = classify.ClassifyName
        this.searchData['classify2'] = ''
        this.searchData['classify2Name'] = ''
        this.seconds = classify.Children
      }
      if (level === 2) {
        this.seconds.forEach(i => {
          i.isCheck = false
          if (i.Id === classify.Id) {
            i.isCheck = true
          }
        })

        this.searchData['classify2'] = classify.Id
        this.searchData['classify2Name'] = classify.ClassifyName
      }

      // 初始化Offset
      this.searchData.Offset = 0
      // 清空table
      this.dataList = []
      this.loadData(1)
      this.$forceUpdate()
    },
    searchBrand(brand) {
      this.brands.forEach(i => {
        i.isCheck = false
      })
      // this.searchParams['brandId'] = brand.Id
      // this.searchParams['brandName'] = brand.Name
      this.searchData['BrandIds'] = brand.Id
      this.searchData['BrandName'] = brand.Name
      brand.isCheck = true
      // 初始化Offset
      this.searchData.Offset = 0
      // 清空table
      this.dataList = []
      this.loadData(1)
      this.$forceUpdate()
    },
    searchMedicalTypes(brand) {
      const arry = []
      this.MedicalTypes.forEach(i => {
        if (i.Id === brand.Id) {
          i.isCheck = !i.isCheck
        }
        if (i.isCheck) {
          arry.push(i.Id)
        }
      })

      this.searchData['MedicalTypes'] = arry.join(',')
      // 初始化Offset
      this.searchData.Offset = 0
      // 清空table
      this.dataList = []
      this.loadData(1)
      this.$forceUpdate()
    },
    /*
     * 是否非控销勾选点击
     */
    isUnControlHanld() {
      // this.searchParams.isUnControl = !this.searchParams.isUnControl
      this.searchData.IsUnControl = !this.searchData.IsUnControl
      // 初始化Offset
      this.searchData.Offset = 0
      // 清空table
      this.dataList = []
      this.loadData(1)
      this.$forceUpdate()
    },
    /*
     * 我的控销勾选点击
     */
    myGroupControlHanld() {
      // this.searchParams.myGroupControl = !this.searchParams.myGroupControl
      this.searchData.MyGroupControl = !this.searchData.MyGroupControl
      // 初始化Offset
      this.searchData.Offset = 0
      // 清空table
      this.dataList = []
      this.loadData(1)
      this.$forceUpdate()
    },
    /*
     * 可添加控销勾选点击
     */
    isContinueGroupControlHanld() {
      this.searchData.IsContinueGroupControl = !this.searchData
        .IsContinueGroupControl
      // 初始化Offset
      this.searchData.Offset = 0
      // 清空table
      this.dataList = []
      this.loadData(1)
      this.$forceUpdate()
    },
    /*
     * 是否新品,销量,价格 排序点击监听
     * @param type {int} 点击类型， 1价格，2销量，3是否新品
     */
    searchOther(type) {
      try {
        if (type === 3) {
          this.searchData.IsNew
            ? (this.searchData.IsNew = false)
            : (this.searchData.IsNew = true)
        } else {
          this.searchData.IsSortAsc
            ? (this.searchData.IsSortAsc = false)
            : (this.searchData.IsSortAsc = true)
        }
      } catch (error) {
        console.log(error)
      }

      this.searchData.SortType = type
      // 初始化Offset
      this.searchData.Offset = 0
      // 清空table
      this.dataList = []
      this.loadData(1)
    },

    changeOther(e, key) {
      // 初始化Offset
      this.searchData.Offset = 0
      // 清空table
      this.dataList = []
      this.loadData(1)
    },
    getShowTitle() {
      const arr = []
      if (this.$route.query.keyword) {
        arr.push('关键字: ' + this.$route.query.keyword)
      }
      if (
        this.searchData['BrandName'] !== '' &&
        this.searchData['BrandName'] !== undefined
      ) {
        arr.push(this.searchData['BrandName'])
      }
      if (
        this.searchData['classify1Name'] !== '' &&
        this.searchData['classify1Name'] !== undefined
      ) {
        arr.push(this.searchData['classify1Name'])
      }
      if (
        this.searchData['classify2Name'] !== '' &&
        this.searchData['classify2Name'] !== undefined
      ) {
        arr.push(this.searchData['classify2Name'])
      }
      if (this.$route.query.name) arr.push(this.$route.query.name)
      return arr
    },
    clearTitle(item) {
      switch (item) {
        case this.searchData['BrandName']:
          this.searchData['BrandIds'] = ''
          this.searchData['BrandName'] = ''
          this.brands.forEach(i => {
            i.isCheck = false
          })
          break
        case this.searchData['MedicalTypesName']:
          this.searchData['MedicalTypes'] = []
          this.searchData['MedicalTypesName'] = []
          this.MedicalTypes.forEach(i => {
            i.isCheck = false
          })
          break
        case this.searchData['classify1Name']:
          this.searchData['classify1'] = ''
          this.searchData['classify1Name'] = ''
          this.searchData['classify2'] = ''
          this.searchData['classify2Name'] = ''
          this.classifys.forEach(i => {
            i.isCheck = false
          })
          this.seconds = []
          // this.seconds.forEach((i) => {
          //   i.isCheck = false
          // })
          break
        case this.searchData['classify2Name']:
          this.searchData['classify2'] = ''
          this.searchData['classify2Name'] = ''
          this.seconds.forEach(i => {
            i.isCheck = false
          })
          break
        case this.$route.query.name:
          this.searchData['ClassIds'] = ''
          this.searchData['classify1'] = ''
          this.searchData['classify1Name'] = ''
          this.searchData['classify2'] = ''
          this.searchData['classify2Name'] = ''
          this.$router.push({
            query: merge(this.$route.query, { category: '', name: '' })
          })
          break
        case '关键字: ' + this.$route.query.keyword:
          this.searchData['keyword'] = ''
          this.$router.push({
            query: merge(this.$route.query, { keyword: '' })
          })
          break
      }
      // switch (item) {
      //   case this.searchParams['brandName']:
      //     this.searchParams['brandId'] = ''
      //     this.searchParams['brandName'] = ''
      //     this.brands.forEach((i) => {
      //       i.isCheck = false
      //     })
      //     break
      //   case this.searchParams['medicalTypesName']:
      //     this.searchParams['medicalType'] = []
      //     this.searchParams['medicalTypesName'] = []
      //     this.medicalTypes.forEach((i) => {
      //       i.isCheck = false
      //     })
      //     break
      //   case this.searchParams['classify1Name']:
      //     this.searchParams['classify1'] = ''
      //     this.searchParams['classify1Name'] = ''
      //     this.searchParams['classify2'] = ''
      //     this.searchParams['classify2Name'] = ''
      //     this.classifys.forEach((i) => {
      //       i.isCheck = false
      //     })
      //     this.seconds = []
      //     // this.seconds.forEach((i) => {
      //     //   i.isCheck = false
      //     // })
      //     break
      //   case this.searchParams['classify2Name']:
      //     this.searchParams['classify2'] = ''
      //     this.searchParams['classify2Name'] = ''
      //     this.seconds.forEach((i) => {
      //       i.isCheck = false
      //     })
      //     break
      //   case this.$route.query.name:
      //     this.searchParams['operatingClassifyId'] = ''
      //     this.searchParams['classify1'] = ''
      //     this.searchParams['classify1Name'] = ''
      //     this.searchParams['classify2'] = ''
      //     this.searchParams['classify2Name'] = ''
      //     this.$router.push({
      //       query: merge(this.$route.query, { category: '', name: '' })
      //     })
      //     break
      //   case '关键字: ' + this.$route.query.keyword:
      //     this.searchParams['keyword'] = ''
      //     this.$router.push({
      //       query: merge(this.$route.query, { keyword: '' })
      //     })
      //     break
      // }
      this.$forceUpdate()
      this.loadData(1)
    },
    onScroll(e) {
      this.isFixed = e.isFixed
    }
  }
}
</script>

<style lang="less" scoped>
#Search-Page {
  margin: auto;
  width: 1200px;
  max-width: 1200px;

  .goods-item {
    width: 227px;
    background: #FFFFFF;
    cursor: pointer;
  }

  .flex-row {
    display: flex;
    flex-direction: row;
  }

  .search-classify-div {
    margin: 20px 0;
    background: white;

    .search-classify {
      position: relative;
      padding-right: 70px;
      box-shadow: 0 0 1px 0 #E8E8E8;

      .open_close {
        position: absolute;
        top: 20px;
        right: 10px;
        overflow: hidden;
        border: 1px solid #C5CAD5;
        width: 66px;
        height: auto;
        line-height: 22px;
        cursor: pointer;

        &:hover {
          border-color: #0F6EE9;
          color: #0F6EE9;
        }
      }

      &:last-child {
        border-bottom: 0;
      }

      .title {
        padding: 20px;
        width: 156px;
        font-size: 14px;
        text-align: left;
        color: rgba(153, 153, 153, 1);
      }

      .classify-listbox {
        overflow: hidden;
        padding-top: 20px;
        width: calc(100% - 156px);
        height: 40px;
        flex-wrap: wrap;

        .a-classify,
        .classify {
          padding: 0 50px 20px 0;
          font-size: 14px;
          color: rgba(34, 34, 34, 1);
          cursor: pointer;

          &:hover {
            font-weight: 600;
            color: #0F6EE9;
          }
        }

        .a-classify {
          font-weight: 600;
          color: #0F6EE9;
        }
      }
    }

    .extends {
      .classify-listbox {
        height: auto;
      }

      .el-icon-arrow-down {
        transform: rotate(180deg);
      }
    }
  }

  .fixed-search-other-div,
  .search-other-div {
    justify-content: space-between;

    .search-other {
      .a-order-block,
      .order-block,
      .a-other-block,
      .other-block {
        position: relative;
        border: 1px solid #C5CAD5;
        width: 98px;
        height: 30px;
        font-size: 14px;
        text-align: center;
        color: #111A34;
        background: #FFFFFF;
        line-height: 30px;
        cursor: pointer;
      }

      .other-block,
      .order-block {
        &:hover {
          border: 1px solid rgba(15, 110, 233, 1);
          color: #0F6EE9;
        }
      }

      .a-other-block {
        border: 1px solid rgba(15, 110, 233, 1);
        border: none;
        color: rgba(255, 255, 255, 1);
        background: rgba(15, 110, 233, 1);
      }

      .a-order-block,
      .order-block {
        text-align: left;

        .order {
          margin-left: 15px;
        }

        .order::after {
          position: absolute;
          top: calc((28px - 10px) / 2);
          margin-left: 4px;
          width: 9px;
          height: 10px;
          background: url("../../assets/goods/order.png") no-repeat center;
          background-size: cover;
          content: "";
        }
      }

      .a-order-block {
        border: 1px solid rgba(15, 110, 233, 1);
        border: none;
        color: white;
        background: #0F6EE9;

        .order-desc,
        .order-asc {
          margin-left: 15px;
        }

        .order-asc::after {
          position: absolute;
          top: calc((28px - 10px) / 2);
          margin-left: 4px;
          width: 9px;
          height: 10px;
          background: url("../../assets/goods/order-asc.png") no-repeat center;
          background-size: cover;
          content: "";
        }

        .order-desc::after {
          position: absolute;
          top: calc((28px - 10px) / 2);
          margin-left: 4px;
          width: 9px;
          height: 10px;
          background: url("../../assets/goods/order-desc.png") no-repeat center;
          background-size: cover;
          content: "";
        }
      }

      .van-checkbox {
        display: box;
        display: flex;
        display: flex;
        // -webkit-box-align: center;
        // -webkit-align-items: center;
        align-items: flex-start;
        overflow: hidden;
        cursor: pointer;
        user-select: none;
        user-select: none;
      }

      /deep/ .van-checkbox .van-checkbox__icon {
        margin-top: 2px;
        height: 24px;

        .van-icon {
          border: 1px solid rgba(232, 232, 232, 1);
          border-radius: 4px;
          width: 24px;
          height: 24px;
          background: #FFFFFF;
          box-shadow: 0 0 3px 0 rgba(202, 202, 202, .5);
          line-height: 24px;
        }
      }

      /deep/ .van-checkbox .van-checkbox__icon--disabled {
        height: 24px;

        .van-icon {
          background: rgba(245, 245, 245, 1);
        }
      }

      /deep/ .van-checkbox .van-checkbox__icon--checked {
        height: 24px;

        .van-icon {
          background: #0F6EE9;
        }
      }

      /deep/ .van-checkbox__label {
        margin-top: 2px;
        font-size: 14px;
        color: rgba(34, 34, 34, 1);
        line-height: 24px;
      }
    }
  }

  .fixed-search-other-div {
    padding: 10px 0;
    width: 100%;
    background: white;

    // max-width: 1200px;
    // margin-left: calc((100vw - 1200px) / 2);
    > :first-child {
      padding-left: calc((100vw - 1200px) / 2);
    }

    > :last-child {
      padding-right: calc((100vw - 1200px) / 2 - 20px);
    }
  }

  .search-listbox {
    position: relative;
    max-width: 1200px;
    flex-wrap: wrap;

    > div:nth-child(odd) {
      margin: 20px 16px 0 0;
    }

    > div:nth-child(even) {
      margin: 20px 16px 0 0;
    }

    > div:nth-child(5n + 0) {
      margin: 20px 0 0;
    }
  }

  .search-pagination {
    padding: 40px 0;
  }
}

/deep/.flex-box {
  display: flex;
  margin: 20px 0;
  padding: 0;
  background: #FFFFFF;
  flex-wrap: wrap;

  .item {
    width: calc(calc(100% / 5));
  }
}

/deep/.page-view {
  margin-bottom: 20px;
  color: #999999;
}
</style>
